// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"a024d81ceba98e65","src_app_performancedashboard_performancedashboard_module_ts":"65387f88e025f833","src_app_misc_misc_module_ts":"75ff46f710dfd89c"}[chunkId] + ".js";
};